import { useCallback } from 'react';

import { useAnalyticsUtilities } from '@air/analytics';

import META from '~/hooks/events/useTrackSearched.meta';

export type TrackSearchedParams = {
  query: string;
};

export const useTrackSearched = () => {
  const { track } = useAnalyticsUtilities();

  const trackSearched = useCallback(
    (params: TrackSearchedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackSearched };
};
